import { render, staticRenderFns } from "./MyQuestion.vue?vue&type=template&id=7b021445&scoped=true"
import script from "./MyQuestion.vue?vue&type=script&lang=js"
export * from "./MyQuestion.vue?vue&type=script&lang=js"
import style0 from "./MyQuestion.vue?vue&type=style&index=0&id=7b021445&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b021445",
  null
  
)

export default component.exports